import React from 'react';
import BasketProduct from './BasketProduct.jsx';
import {connect} from 'react-redux';
import {clearStore} from '../redux.js';

class Basket extends React.Component{
	constructor(props){
		super(props);
		this.state={
			readyToPay: false
		};
	}
	render(){
		if(this.props.store.length<1)return <div className='empty'>кошик порожнiй :(</div>
		return(
			<section className='basket'>
				<div className='products'>
					{
						this.props.store.map((i,n) =>{
							return <BasketProduct product={i} key={n}/>
						})
					}
				</div>
				{
					!this.state.readyToPay?
					(
						<div className='pay'>
							<div>сума: 
								{
									this.props.store.reduce((sum, i) =>{
										return sum+i.price*i.quantity;
									},0)
								}
								$</div>
							<button onClick={() =>this.setState({readyToPay:true})}>купити</button>
						</div>
					):(
						<div className='pay-systems'>
							<div className='anime show'>оберiть платiжну систему</div>
							<img onClick={() =>alert('paysystems are not working yet')}
								src={require('../../img/basket/visa.png')}/>
							<img onClick={() =>alert('paysystems are not working yet')}
								src={require('../../img/basket/paypal.png')}/>
							<img onClick={() =>alert('paysystems are not working yet')}
								src={require('../../img/basket/master.png')}/>
						</div>
					)
				}
			</section>
		)
	}
}

export default connect(
	state =>({
		store: state
	}),
	dispatch =>({
		clearStore:()=>{
			dispatch(clearStore())
		}
	})
)(Basket);